/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-unknown-property */
import React, { HTMLProps } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SupportIcon } from 'assets/icons_3/help-circle.svg';
import { ReactComponent as HelpIcon } from 'assets/icons_3/headphones-02.svg';
import { ReactComponent as HelpIcon2 } from 'assets/icons_3/help-circle-2.svg';
import { ReactComponent as TelegramIcon } from 'assets/icons_3/telegram.svg';
import { ReactComponent as WhatsAppIcon } from 'assets/icons_3/whatsapp.svg';
import OverlayTrigger from 'components/UI_kit_3/Popover/OverlayTrigger/OverlayTrigger';
import NavLink from 'components/SideMenu/NavLink/NavLink';
import Popover from 'components/UI_kit_3/Popover/Popover';
import DropdownItem from 'components/UI_kit_3/Popover/DropdownItem/DropdownItem';
import { useAppSelector } from 'hooks';
import styles from './HelpCard.module.scss';

interface IHelpCardProps extends HTMLProps<HTMLDivElement> {

}

const HelpCard: React.FC<IHelpCardProps> = ({ className }) => {
  const [t] = useTranslation();
  const countryCode = useAppSelector((state) => state.user.country?.code);

  return (
    <OverlayTrigger
      className={styles.helpCard}
      animationDuration={100}
      position="bottom-right"
      overlay={(
        <Popover className={styles.list} qa-element="help-card-popover">
          <DropdownItem href="https://helpdesk.pro-data.tech" target="_blank" qa-element="help-card-support">
            <HelpIcon />
            {t('auth.support')}
          </DropdownItem>
          <DropdownItem href="https://helpdesk.pro-data.tech/portal/ru/kb/faq" target="_blank" qa-element="help-card-faq">
            <HelpIcon2 />
            {t('contacts.faq')}
          </DropdownItem>
          {countryCode === 'KZ' && (
          <DropdownItem href="https://wa.me/77475073022" target="_blank" qa-element="help-card-whatsapp">
            <WhatsAppIcon />
            {t('auth.whatsapp')}
          </DropdownItem>
          )}
          {countryCode === 'UZ' && (
          <DropdownItem href="https://t.me/PRO_DATA_Support_Bot" target="_blank" qa-element="help-card-telegram">
            <TelegramIcon />
            {t('auth.telegram')}
          </DropdownItem>
          )}
        </Popover>
    )}
    >
      <NavLink className={classNames(styles.toggle, className, 'ml-auto mr-2xs')} Icon={SupportIcon} qa-element="help-card-toggle" />
    </OverlayTrigger>
  );
};

export default HelpCard;
